// material-ui
import Box from '@mui/material/Box';

// assets
import logoNameUrl from '../../../../assets/logo/logoName.svg'
import logoUrl from '../../../../assets/logo/logo.svg'

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

export default function Logo() {
  return (
    <Box sx={{ width: '100%', ml: { xs: 0, md: 1 }, display: 'flex',alignItems: 'center' }}>
      <Box
      component='img'
      src={logoUrl}
      sx={{
        width: '1.6rem',
        ml: '0.3rem'
      }}
      />
      <Box
      component='img'
      src={logoNameUrl}
      sx={{
        width: '10rem',
        ml: '0.2rem'
      }}
      />
    </Box>
  );
}
